module.exports = __webpack_public_path__ + "img/jens_kuchenbecker.8bddaf0f.jpeg";